/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PriceDiscountType {
  FIRST_MONTH_FREE = 'first_month_free',
  FLAT_UPGRADE_DISCOUNT = 'flat_upgrade_discount',
  CUSTOM = 'custom',
  FREE_MONTH = 'free_month',
  STUDENT_DISCOUNT = 'student_discount',
}
